import DeleteAppSystemRequestModelBase from '../_generated/modelBases/delete-app-system-request-model-base';

export default class DeleteAppSystemRequestModel extends DeleteAppSystemRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
